import React, { useState } from 'react';
import { Menu } from 'antd';
import { NavLink, useRouteMatch } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';

const MenuItems = ({ toggleCollapsed }) => {
  const { path } = useRouteMatch();
  const pathName = window.location.pathname.split('/');
  const slug = window.location.pathname.replace('/admin/', '');
  const [openKeys, setOpenKeys] = useState(pathName.length > 2 ? pathName.slice(2, pathName.length) : []);
  /* click on sub menu with item */
  const onOpenChange = keys => {
    setOpenKeys([keys.pop()]);
  };
  /* click on sub menu without items */
  const onClick = item => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };
  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode="inline"
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
      defaultSelectedKeys={[slug]}
    >
      <Menu.Item
        key="actif"
        icon={
          <NavLink className="menuItem-iocn" to={`${path}`}>
            <FeatherIcon icon="home" />
          </NavLink>
        }
      >
        <NavLink onClick={toggleCollapsed} to={`${path}`}>
          {/* Dashboard */}
          Dashboard
        </NavLink>
      </Menu.Item>
      <Menu.Item
        key="employees"
        icon={
          <NavLink className="menuItem-iocn" to={`${path}/employees`}>
            <FeatherIcon icon="users" />
          </NavLink>
        }
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/employees`}>
          Gestion des utilisateurs
        </NavLink>
      </Menu.Item>
      <Menu.Item
        key="request"
        icon={
          <NavLink className="menuItem-iocn" to={`${path}/request`}>
            <FeatherIcon icon="calendar" />
          </NavLink>
        }
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/request`}>
          {/* Gestion des congés */}
          Demandes des congés
        </NavLink>
      </Menu.Item>
      <Menu.Item
        key="authorizations"
        icon={
          <NavLink className="menuItem-iocn" to={`${path}/authorizations`}>
            <FeatherIcon icon="clock" />
          </NavLink>
        }
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/authorizations`}>
          {/* Gestion des autorisations */}
          Demandes des autorisations
        </NavLink>
      </Menu.Item>
      <Menu.Item
        key="remote"
        icon={
          <NavLink className="menuItem-iocn" to={`${path}/remote`}>
            <FeatherIcon icon="briefcase" />
          </NavLink>
        }
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/remote`}>
          {/* Gestion des TT */}
          Demande de TT
        </NavLink>
      </Menu.Item>
    </Menu>
  );
};
MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
